import React from 'react';
import { AiStarsIcon } from '@/components';
import { useTranslation } from 'react-i18next';
import { CarrierPreviewItem } from '@/types';
import SmartCarrierMatchItem from './SmartCarrierMatchItem';

interface SmartCarrierMatchProps {
  carrierList: CarrierPreviewItem[];
  isLoading?: boolean;
  isPreviewMode?: boolean;
  /**
   * Optional custom empty-state text shown when `carrierList` is empty.
   * Reusable primitive — no production caller wires it yet (the create/edit
   * "no temp-control carrier serves {province}" clarity lands via NoCarrierModal).
   */
  emptyStateMessage?: string;
}

const SmartCarrierMatch: React.FC<SmartCarrierMatchProps> = ({
  carrierList,
  isLoading,
  isPreviewMode,
  emptyStateMessage,
}) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col gap-3'>
      {/* Header */}
      <div className='flex items-center justify-between'>
        <span className='text-[14px] font-bold text-[rgb(57,57,60)]'>
          {String(t('smart_carrier_match'))}
        </span>
        <AiStarsIcon loading={isLoading} />
      </div>

      {isLoading ? (
        <div className='flex flex-col items-center gap-3 py-4'>
          <div className='flex items-center gap-2.5'>
            <div className='w-8 h-8 rounded-lg bg-[rgb(232,230,227)] animate-pulse' />
            <div className='w-8 h-8 rounded-lg bg-[rgb(232,230,227)] animate-pulse' style={{ animationDelay: '0.1s' }} />
            <div className='w-8 h-8 rounded-lg bg-[rgb(232,230,227)] animate-pulse' style={{ animationDelay: '0.2s' }} />
            <div className='w-8 h-8 rounded-lg bg-[rgb(232,230,227)] animate-pulse' style={{ animationDelay: '0.3s' }} />
          </div>
          {isPreviewMode && (
            <span className='text-[12px] text-[rgb(115,123,140)] text-center mt-2'>
              {String(t('add_order_info_to_have_Boxy_AI_select_the_best_carrier_match_for_your_order'))}
            </span>
          )}
        </div>
      ) : (
        <div className='flex flex-col gap-2'>
          {carrierList.length > 0 ? (
            carrierList.map((carrier, index) => (
              <SmartCarrierMatchItem
                key={carrier.carrier.uid + 'index' + index}
                carrier={carrier}
              />
            ))
          ) : (
            <span className='text-[13px] text-[rgb(115,123,140)] py-2'>
              {emptyStateMessage ?? String(t('carrierHoverCell.noCarrierAssigned'))}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default SmartCarrierMatch;
